import { TabContainer as Container } from './TabContainer';
import { TabContent as Content } from './TabContent';
import { TabItem as Item } from './TabItem';
import { TabMenu as Menu } from './TabMenu';
import { TabMenuItem as MenuItem } from './TabMenuItem';
export * from './Tab.decl';
export var Tab = {
  Container: Container,
  Content: Content,
  Item: Item,
  Menu: Menu,
  MenuItem: MenuItem
};